import classes from './ArticleCookingClassHero.module.scss'
import ResponsiveImage from '@/components/ResponsiveImage'
import Image from 'next/image'
import CookingClassSignupForm from '@/components/Forms/CookingClassSignupForm'
import Link from 'next/link'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import { getBackNavigationInfo } from '@/utils/getBackNavigationInfo'
import ResponsiveComponent from '@/components/ResponsiveComponent'

const IconBullet = dynamic(() => import('@/svgs/list-item.svg'))

const ArticleCookingClassHero = ({ fields }) => {
  fields = {
    title: fields.title,
    ...fields.fields,
    featuredClass: {
      listId: fields.fields.featuredClass.klaviyoListId,
      ...fields.fields.featuredClass,
    },
  }

  const router = useRouter()
  const goBackNavigationSettings = getBackNavigationInfo(router)

  const { hero } = fields

  return (
    <div className={`article-cooking-class-hero container`}>
      <div className={classes['article-cooking-class-hero__navigation']}>
        {goBackNavigationSettings.url && (
          <Link href={goBackNavigationSettings.url}>
            <IconBullet />{' '}
            <span>Back to all {goBackNavigationSettings.title}</span>
          </Link>
        )}
      </div>
      <div className={classes['article-cooking-class-hero__header']}>
        <h1>{fields.title}</h1>
        <h2>{fields.subheader}</h2>
      </div>
      <div className={classes['article-cooking-class-hero__wrapper']}>
        <div className={classes['article-cooking-class-hero__image']}>
          <ResponsiveComponent
            desktopBreakpoint={'md'}
            mobile={
              hero?.mobileBackgroundImage && (
                <ResponsiveImage
                  priority={true}
                  src={hero?.mobileBackgroundImage.asset.url}
                  alt={hero?.mobileBackgroundImage.alt || ''}
                />
              )
            }
            desktop={
              hero?.desktopBackgroundImage && (
                <Image
                  sizes="50vw"
                  priority={true}
                  src={hero?.desktopBackgroundImage.asset.url}
                  layout="fill"
                  alt={hero?.desktopBackgroundImage.alt || ''}
                />
              )
            }
          />
        </div>
        <div className={classes['article-cooking-class-hero__content']}>
          <CookingClassSignupForm fields={fields.featuredClass} />
        </div>
      </div>
    </div>
  )
}

export default ArticleCookingClassHero
